var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdouinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO_BDOUIN",
    "data-name": "LOGO BDOUIN",
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.353,
    height: 176.921,
    viewBox: "0 0 216.353 176.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(4.604 2.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    d: "M184.943,247.071a60.1,60.1,0,0,1-10.168.858,58.33,58.33,0,0,1-19-3.115h-.059c-17.738,0-32.115-7.306-32.115-16.317,0-3.43,2.083-6.613,5.642-9.239a27.87,27.87,0,0,1-.894-7c0-18.712,18.747-34.055,42.6-35.555a30.454,30.454,0,0,1,9.139-10.281c5.147-15.77,20.994-27.1,50.244-27.219,25.175-.1,46.183,13.552,51.068,31.632,15.7,3.114,25.438,14.289,26.852,27.109,12.361,3.716,21.094,12.841,21.094,23.509,0,13.968-14.976,25.291-33.45,25.291a42.739,42.739,0,0,1-13.31-2.082,75.471,75.471,0,0,1-25.7,4.307q-1.334,0-2.651-.042a84.909,84.909,0,0,1-32.652,6.123C207.462,255.049,194.606,252.027,184.943,247.071Z",
    transform: "translate(-123.599 -139.199)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Forme_2",
    "data-name": "Forme 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forme_2-2",
    "data-name": "Forme 2",
    d: "M191.362,144.343s55.922-31.744,90.929,22.992c6.749.223,23.437,3.708,26.552,28.48,7.862.89,31.447,11.273,21.064,35.155s-47.616,14.24-47.616,14.24c.663.423-16.924,6.4-29.074,3.56C249,251.1,216.536,267.461,182,247.527c-6.216.948-25.8.206-33.51-3.651-14.03,1.773-47.348-5.713-24.624-27.145-1.541-6.642-8.967-40.849,39.947-43.524,3.071-3.2,9.746-11.36,28.436-16.107-1.038,4.3-.742,3.56-.742,3.56s-14.537,1.632-22.7,13.2c4.747,2.225,2.67.742,6.972,3.708-7.862-.742-50.582-3.115-47.764,39.309-3.56,3.56-16.02,17.207,9.938,21.805,3.412.593,11.867,1.632,17.059-3.857.3,2.67-3.263,5.043-5.34,5.933,4.005,1.187,18.1,6.082,33.672,2.522,7.417,3.412,27.59,15.13,68.382,1.038,5.34.148,14.537.593,23.585-2.967-4.9-5.34-2.744-5.34-1.632-4.747,5.34,6.378,38.715,14.982,48.8-7.268s-11.273-36.194-31-29.519c1.187-2.893,7.565-4.6,12.015-4.6,0-6.906-11.481-36.775-41.435-17.958-1.952-1.844,8.653-9.333,14.884-9.632-5.413-6.072-34-39.243-82.307-21.285C188.544,148.941,184.539,149.238,191.362,144.343Z",
    transform: "translate(-116.15 -135.189)",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_arrondi_1",
    "data-name": "Rectangle arrondi 1",
    transform: "translate(50.439 118.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_arrondi_1-2",
    "data-name": "Rectangle arrondi 1",
    d: "M216.581,327.015a5.584,5.584,0,0,1,3.2,7.216l-11.233,29.177a5.583,5.583,0,0,1-10.419-4.012l11.233-29.177A5.582,5.582,0,0,1,216.581,327.015Z",
    transform: "translate(-197.758 -326.64)",
    fill: "#98daf9",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_arrondi_1_copie",
    "data-name": "Rectangle arrondi 1 copie",
    transform: "translate(101.546 136.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_arrondi_1_copie-2",
    "data-name": "Rectangle arrondi 1 copie",
    d: "M299.932,356.522a5.584,5.584,0,0,1,3.2,7.216L291.9,392.916a5.582,5.582,0,0,1-7.215,3.2c-2.877-1.108-5.053-4.487-3.946-7.365l11.234-29.177C293.083,356.7,297.055,355.414,299.932,356.522Z",
    transform: "translate(-280.448 -356.126)",
    fill: "#98daf9",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_arrondi_1_copie_2",
    "data-name": "Rectangle arrondi 1 copie 2",
    transform: "translate(142.998 116.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_arrondi_1_copie_2-2",
    "data-name": "Rectangle arrondi 1 copie 2",
    d: "M360.482,324.02a3.864,3.864,0,0,1,2.206,4.988l-7.737,20.167a3.846,3.846,0,1,1-7.176-2.773l7.736-20.167a3.841,3.841,0,0,1,4.97-2.215Z",
    transform: "translate(-347.516 -323.763)",
    fill: "#98daf9",
    fillRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_arrondi_1_copie_3",
    "data-name": "Rectangle arrondi 1 copie 3",
    transform: "translate(162.579 128.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_arrondi_1_copie_3-2",
    "data-name": "Rectangle arrondi 1 copie 3",
    d: "M392.162,343.941a3.863,3.863,0,0,1,2.207,4.988L386.631,369.1a3.846,3.846,0,1,1-7.176-2.773l7.737-20.167a3.84,3.84,0,0,1,4.969-2.215Z",
    transform: "translate(-379.196 -343.684)",
    fill: "#98daf9",
    fillRule: "evenodd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_arrondi_1_copie_4",
    "data-name": "Rectangle arrondi 1 copie 4",
    transform: "translate(24.333 118.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_arrondi_1_copie_4-2",
    "data-name": "Rectangle arrondi 1 copie 4",
    d: "M167.361,327.116a3.51,3.51,0,0,1,2.016,4.537L162.31,350a3.512,3.512,0,1,1-6.555-2.522l7.067-18.343A3.513,3.513,0,0,1,167.361,327.116Z",
    transform: "translate(-155.52 -326.88)",
    fill: "#98daf9",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdouinLogo);
export default __webpack_public_path__ + "static/media/bdouin-logo.fe615d1ef8d7df244ee085cbf2684759.svg";
export { ForwardRef as ReactComponent };